import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocalStorageService } from '../../services/local-storage.service';
import { EFooterStyleInput } from '../../data-types/footer.enum';
import { EStorageType } from '../../data-types/storage.enum';
import { IAppState } from '../../store/state/app.state';
import { iconsLibrary } from '../../../theme/constants';
import { CompanyService } from '../../services/company.service';
import { closeLoadingAction, showLoadingAction, } from '../../store/actions/loading.action';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { EInputStyleType } from '../../data-types/input-style.enum';
import { showAlertAction } from '../../store/actions/alert.action';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CoworkerService } from '../../services/coworker.service';

@Component({
  selector: "cowing-core-spendings-home",
  templateUrl: "./company-home-spendings.component.html",
  styleUrls: ["./company-home-spendings.component.scss"],
})
export class CompanySpendingsHomeComponent implements OnInit, OnDestroy {
  public EFooterStyleInput = EFooterStyleInput;
  public EInputStyleType = EInputStyleType;
  public coworkingId;
  public spendingsList = [];
  public nextPage = null;
  public previousPage = null;
  public pageSize = 10;
  iconsLibrary;
  subscription = new Subscription();
  filterForm: FormGroup;
  @Input('companyId') companyId = 0;
  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    moment.locale("es");
    this.filterForm = this.formBuilder.group({
      page: new FormControl(0),
      dateStart: new FormControl(null),
      dateEnd: new FormControl(null),
    });
  }

  public setDateStart(event) {
    const dateStart = moment(event).format('DD/MM/yyyy');
    if (typeof event === 'string') {
      this.filterForm.get('dateStart').setValue(dateStart);
    }
  }

  public setDateEnd(event) {
    const dateEnd = moment(event).format('DD/MM/yyyy');
    if (typeof event === 'string') {
      this.filterForm.get('dateEnd').setValue(dateEnd);
    }
  }

  async ngOnInit() {
    this.subscription.add(
      CoworkerService.instance.coworkingStatusModified.subscribe(
        async (value) => {
          try {
            this.spendingsList = [];
            this._store.dispatch(showLoadingAction({}));

            await this.getSpendings();
          } catch (e) {
            this._store.dispatch(
              showAlertAction({
                payload: {
                  message:
                    e.status === 401
                      ? this.translate.instant("general.expired")
                      : e.data.error,
                  title: this.translate.instant("general.caution"),
                  type: "error",
                },
              })
            );
          } finally {
            this._store.dispatch(closeLoadingAction({}));
          }
        }
      )
    );
    this.subscription.add(
      this.filterForm.valueChanges.subscribe(async (newValue) => {
        try {
          this.spendingsList = [];
          this._store.dispatch(showLoadingAction({}));

          await this.getSpendings();
        } catch (e) {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message:
                  e.status === 401
                    ? this.translate.instant("general.expired")
                    : e.data.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
        } finally {
          this._store.dispatch(closeLoadingAction({}));
        }
      })
    );
    this.subscription.add(
      CompanyService.instance.newCompanySelected.subscribe(
        async (newValue) => {
          this.coworkingId = newValue;
          try {
            this.spendingsList = [];
            this._store.dispatch(showLoadingAction({}));
            await this.getSpendings();
          } catch (e) {
            this._store.dispatch(
              showAlertAction({
                payload: {
                  message:
                    e.status === 401
                      ? this.translate.instant("general.expired")
                      : e.data.error,
                  title: this.translate.instant("general.caution"),
                  type: "error",
                },
              })
            );
          } finally {
            this._store.dispatch(closeLoadingAction({}));
          }
        }
      )
    );
    this.coworkingId = LocalStorageService.instance.get(
      EStorageType.ActiveCoworking
    );
    this._store.dispatch(showLoadingAction({}));
    try {
      await this.getSpendings();
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get getCalendarIcon() {
    return `${iconsLibrary.calendarEmpty}`;
  }

  public async getSpendings() {
    const params = {
      page: this.filterForm.get('page').value,
      dateStart: this.filterForm.get('dateStart').value,
      dateEnd: this.filterForm.get('dateEnd').value
    };
    const {total_elements, total_pages, page_number, spendings}  = await CompanyService.instance.getCompanySpendings(
      this.companyId,
      params,
      this.pageSize
    );

    this.previousPage = this.getPrevPage(page_number);
    this.nextPage = this.getNextPage(page_number, total_elements, this.pageSize);

    this.spendingsList = spendings;
  }

  private getPrevPage(currentPage) {
    if (currentPage > 1) {
      return currentPage--;
    }
    return null;
  }

  private getNextPage(currentPage, totalElements, pageSize) {
    const numPages = Math.ceil(totalElements / pageSize);
    if (currentPage > 0 && currentPage < numPages) {
      return currentPage++;
    }
    return null;
  }

  public get getEditIcon() {
    return `${iconsLibrary["editSvg"]}`;
  }

  public get getLeftArrowIcon() {
    return `${iconsLibrary["leftArrowTable"]}`;
  }

  public get getRightArrowIcon() {
    return `${iconsLibrary["rightArrowTable"]}`;
  }

  public get getDisabledLeftArrowIcon() {
    return `${iconsLibrary["disabledLeftArrowTable"]}`;
  }

  public get getDisabledRightArrowIcon() {
    return `${iconsLibrary["disabledRightArrowTable"]}`;
  }

  public setNextPage() {
    this.filterForm.get("page").setValue(this.filterForm.get("page").value + 1);
  }

  public setPreviousPage() {
    this.filterForm.get("page").setValue(this.filterForm.get("page").value - 1);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getTotalCowings(): number {
    return this.spendingsList.reduce((a, c) => a + c.cowings_spent , 0);
  }
}
